// extracted by mini-css-extract-plugin
export default {"icon":"CustomAddTaskForm_icon__OJxv+"};